import React from "react";

const Navigation = () => {
  return (
    <nav className="navbar">
      <div className="container">
        {/* Logo */}
        <a className="navbar-brand" href="#page-top">
          CODEFORT
        </a>

        {/* Menu Principal */}
        <ul className="navbar-nav">
          <li><a href="#features">Características</a></li>
          <li><a href="#about">Sobre nós</a></li>
          <li><a href="#services">Serviços</a></li>
          <li><a href="#plans">Vendas</a></li>
          <li><a href="#benefits">Benefícios</a></li>
          <li><a href="#contact">Contato</a></li>
        </ul>

        {/* Botão de Login */}
        <div className="login-container">
          <a href="https://codefort.com.br/login" target="_blank" className="btn-login" rel="noreferrer">
            Login
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
